export default "/_next/static/sounds/GENERAL_TAP_3-d20d5343acbada49b262aeca8718e012.mp3";